import React from 'react';
import cx from 'classnames';
import moment from 'moment';

import Divider from '../../Divider';

export const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export type DateRangePickerValueT = {
  startDate?: Date;
  endDate?: Date;
};

interface DateListPropsT {
  month: number;
  year: number;
  onChange: (date: Date) => void;
  dates?: DateRangePickerValueT;
}

const DateList = React.memo(
  React.forwardRef<HTMLDivElement, DateListPropsT>(
    ({ month, year, onChange, dates }, ref) => {
      const a = moment(dates?.startDate);
      const b = moment(dates?.endDate);

      const start = new Date(year, month).getDay();
      const length = new Date(year, month + 1, 0).getDate();

      const isToday = (day: number) =>
        moment(0, 'HH').diff(`${year}-${month + 1}-${day}`, 'days') === 0;

      const isInRange = (day: number) =>
        dates?.startDate &&
        dates?.endDate &&
        b.year() <= year &&
        a.year() >= year &&
        ((b.month() > a.month() && month > a.month() && month < b.month()) ||
          (b.month() > a.month() && month === b.month() && day < b.date()) ||
          (b.month() > a.month() && month === a.month() && day > a.date()) ||
          (b.diff(a, 'days') > 0 &&
            day > a.date() &&
            day < b.date() &&
            (month === b.month() || month === a.month())));

      return (
        <div
          className="date-list-content max-md:pb-2.5 max-md:border-b border-primary"
          ref={ref}
        >
          <p className="text-[16px] font-medium text-left md:text-center leading-10 md:leading-[35px] px-0.5 pb-2.5">
            {MONTH_NAMES[month]} {year}
          </p>

          <div className="calendar-picker max-md:hidden mb-1.5">
            {DAY_NAMES.map((day: string) => (
              <p className="week-name-cell" key={day}>
                {day.charAt(0)}
              </p>
            ))}
          </div>

          <div id={year + '-' + month} className="calendar-picker">
            {Array.from({ length }).map((_, index: number) => (
              <div
                className={cx('calendar-picker-cell', {
                  'bg-primary': isInRange(index + 1),
                })}
                style={index === 0 ? { gridColumn: start + 1 } : {}}
                key={index}
              >
                <p
                  onClick={() => {
                    onChange(new Date(year, month, index + 1));
                  }}
                  className={cx(
                    'cursor-pointer',
                    (dates?.startDate &&
                      index + 1 === a.date() &&
                      ((month === 12 && a.month() === 0) ||
                        month === a.month()) &&
                      a.year() === year) ||
                      (dates?.endDate &&
                        index + 1 === b.date() &&
                        ((month === 12 && b.month() === 0) ||
                          month === b.month()) &&
                        b.year() === year)
                      ? 'text-white bg-uta-black hover:bg-opacity-100 border border-uta-black'
                      : 'text-gray-800 hover:bg-black hover:bg-opacity-5',
                    {
                      'border border-uta-black': isToday(index + 1),
                      'hover:!bg-black hover:!bg-opacity-40 hover:text-white':
                        isInRange(index + 1),
                    }
                  )}
                >
                  {index + 1}
                </p>
              </div>
            ))}
          </div>
        </div>
      );
    }
  )
);

DateList.displayName = 'DateList';
export default DateList;
